module.exports = __webpack_public_path__ + "static/media/EC-Equidade-Racial-anuncio_V002.51df2aed.png";